import { MapDef } from '../defs/map';

export type MapValidationError =
  | 'moves'
  | 'goals'
  | 'rewards'
  | 'rows'
  | 'columns'
  | 'cells';

export function mapValidateDef(
  mapDef: MapDef,
  requireGoals = true,
): boolean | MapValidationError {
  const grid = mapDef.grid;

  // require moves
  if (mapDef.moves <= 0) return 'moves';

  // require goals
  if (
    requireGoals &&
    Object.values(mapDef.goals).reduce((total, count) => total + count, 0) <= 0
  )
    return 'goals';

  // require rewards

  // require valid columns
  if (grid.columns <= 0) return 'columns';

  // require valid rows
  if (grid.rows <= 0) return 'rows';

  // require valid cells
  if (grid.cells.length !== grid.columns) return 'cells';
  for (const rows of grid.cells) {
    if (rows.length !== grid.rows) return 'cells';
  }

  return true;
}
